"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TimeAttendance;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const UserContext_1 = require("../contexts/UserContext");
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const Helper_1 = require("../Helper");
const SingleSignOn_1 = require("../shared/SingleSignOn");
const Screen_1 = __importDefault(require("../components/Screen"));
const MasonryList_1 = __importDefault(require("../components/MasonryList"));
const PtoBalanceCard_1 = __importDefault(require("../partials/PtoBalanceCard"));
const react_i18next_1 = require("react-i18next");
const PtoRequestsCard_1 = __importDefault(require("../partials/PtoRequestsCard"));
const PtoHistoryCard_1 = __importDefault(require("../partials/PtoHistoryCard"));
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
function TimeAttendance(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size, columns, twoPercentOfScreen } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [refreshKey, setRefreshKey] = react_1.default.useState(Date.now());
    const [timeAndAttendance] = react_1.default.useState(userContext.client?.features?.find((feature) => feature.name === 'time-and-attendance'));
    const vendor = timeAndAttendance?.vendor?.toLowerCase();
    const opensExternalTa = vendor === 'kronos' || vendor === 'timeco';
    const hasRedirected = react_1.default.useRef(false);
    react_1.default.useEffect(() => {
        if (!opensExternalTa || hasRedirected.current)
            return;
        hasRedirected.current = true;
        Helper_1.Helper.verifyLocationPermissions().then(_ => {
            switch (vendor) {
                case 'kronos':
                    FirebaseAnalytics_1.default.LogEvent('feature_used', {
                        feature: 'Kronos SSO',
                        client: userContext.client?.id,
                        employee: userContext.employee?.employeeId
                    });
                    SingleSignOn_1.SingleSignOn.Perform({
                        navigation: props.navigation,
                        client: userContext?.client?.id,
                        provider: 'kronos',
                        title: t('common:screenTitles.ta')
                    });
                    break;
                case 'timeco':
                    FirebaseAnalytics_1.default.LogEvent('feature_used', {
                        feature: 'TimeCo SSO',
                        client: userContext.client?.id,
                        employee: userContext.employee?.employeeId
                    });
                    SingleSignOn_1.SingleSignOn.Perform({
                        navigation: props.navigation,
                        client: userContext?.client?.id,
                        provider: 'timeco',
                        title: t('common:screenTitles.ta')
                    });
                    break;
            }
        });
    }, [opensExternalTa, vendor]);
    if (opensExternalTa) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(Screen_1.default, { onRefresh: () => setRefreshKey(Date.now()), children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: columns == 1 ? {} : { marginVertical: 6, marginHorizontal: 16 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Image, { resizeMode: 'cover', source: size != 'sm' ? Theme_1.IMAGES.TimeBackgroundWeb : Theme_1.IMAGES.TimeBackground, style: { width: '100%', height: 'auto', aspectRatio: size != 'sm' ? 11.2 : 5.6, marginTop: size != 'sm' ? 12 : 4, borderRadius: size != 'sm' ? 4 : 0 } }) }), (0, jsx_runtime_1.jsxs)(MasonryList_1.default, { children: [(timeAndAttendance?.isEnabled && (timeAndAttendance?.vendor?.toLowerCase() != 'kronos' || timeAndAttendance?.showKronosPto)) &&
                        (0, jsx_runtime_1.jsx)(PtoBalanceCard_1.default, { navigation: props.navigation }), (timeAndAttendance?.isEnabled && timeAndAttendance?.vendor?.toLowerCase() == 'prismhr') &&
                        (0, jsx_runtime_1.jsx)(PtoHistoryCard_1.default, { navigation: props.navigation }), (timeAndAttendance?.isEnabled && timeAndAttendance?.vendor?.toLowerCase() == 'prismhr') &&
                        (0, jsx_runtime_1.jsx)(PtoRequestsCard_1.default, { navigation: props.navigation })] }, refreshKey)] }));
}
;
